// removed by extract-text-webpack-plugin
module.exports = {"flexPosition":"eZEFi_h7NkJfV4iJgnY27","buttonWrapper":"_11oJGG95I39OTAEKXec1je","buttonWrapperCenter":"_3BVgmaV172j2b-7nzlDmMS"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyStaffContainer/components/FooterMyStaff/FooterMyStaff.scss
// module id = 1837
// module chunks = 0